import { ISoftwareModel } from './softwareModel';
import { IProvinceModel } from './provinceModel';
import { IProfessionalStep1FormResultModel } from '../../components/registration/professional/step1/professionalStep1FormModel';

export interface ILocationModel {
    id?: string;
    name: string;
    address: string;
    city: string;
    province: number | IProvinceModel;
    zip: string;
    phone: string;
    ext: string;
    managementSoftware: number | ISoftwareModel;
    managementSoftwareOther: string;
    agreeManagementSoftware: boolean;
    managementSystem: string;
    retailBanner: string;
}

export class LocationModel {
    public id: string | undefined;
    public name: string | undefined;
    public address: string | undefined;
    public city: string | undefined;
    public province: string | IProvinceModel | undefined;
    public zip: string | undefined;
    public phone: string | undefined;
    public ext: string | undefined;
    public managementSoftware: number | ISoftwareModel | undefined;
    public managementSoftwareOther: string | undefined;
    public agreeManagementSoftware: boolean | undefined;
    public managementSystem: string | undefined;
    public retailBanner: string | undefined;
}

export const locationModelFromFormData = (
    formData: IProfessionalStep1FormResultModel
): ILocationModel => {
    return {
        name: formData.form_professional_step_1_field_company_name,
        address: formData.form_professional_step_1_field_address,
        city: formData.form_professional_step_1_field_city,
        zip: formData.form_professional_step_1_field_postal_code,
        phone: formData.form_professional_step_1_field_phone,
        ext: formData.form_professional_step_1_field_phone_ext,
        managementSystem: '',
        managementSoftwareOther: formData.form_professional_step_1_field_managing_software_other,
        agreeManagementSoftware:
            formData.form_professional_step_1_field_authorization_communication,
        retailBanner: formData.form_professional_step_1_field_commercial_banner,
        managementSoftware: Number(formData.form_professional_step_1_field_managing_software),
    } as ILocationModel;
};
